import styled from "styled-components";

export const Container = styled.div`
  padding: 0 30px 30px 30px;
  .item {
    margin-top: 10px;
  }
  & .upload-wrapper {
    margin-top: 20px;
  }
`;
